import { styled } from '@mui/material';

export const DataLabel = styled('span')(({ isDetail, isDocument, theme }) => ({
  fontWeight: 500,
  fontSize: isDetail ? '10px' : '12px',
  color: isDetail ? theme.palette.colors.label : theme.palette.colors.lower,
  lineHeight: 'normal',
  textTransform: isDetail ? 'uppercase' : 'capitalize',
  marginTop: isDocument ? 0 : 0,
  [theme.breakpoints.up('md')]: {
    marginTop: 0,
    fontSize: isDetail ? '10px' : '12px',
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '10px',
  },
}));

export const DataValue = styled('span')(({ isDocument, theme, isDetail }) => ({
  fontWeight: 500,
  fontSize: isDetail ? '10px' : '12px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  lineHeight: 'normal',
  marginTop: '2px',
  textDecoration: isDocument ? 'underline' : 'unset',
  display: 'flex',
  alignItems: 'center',
  cursor: isDocument ? 'pointer' : 'default',
  '& svg': {
    color: theme.palette.colors.mainFocused,
    marginRight: '4px',
    height: '24px',
    width: '8px',
  },
  '&:hover': {
    cursor: isDocument ? 'pointer' : 'default',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: isDetail ? '10px' : '12px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '10px',
  },
}));
export const DataWrapper = styled('div')(({ isDetail, theme, isWallet }) => {
  const getMarginBottom = () => {
    if (isDetail) {
      if (isWallet) {
        return 12;
      }
      return 8;
    }
    return 4;
  };
  return {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: getMarginBottom(),
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: isDetail ? 12 : 0,
    },
  };
});

export const WrapperValues = styled('div')(({ theme, isDocument }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: isDocument ? 'column' : 'row',
    alignItems: isDocument ? 'flex-start' : 'center',
  },
}));
export const Separator = styled('div')(({ theme }) => ({
  width: '1px',
  height: '12px',
  backgroundColor: theme.palette.colors.lower,
  margin: '0 4px',
}));
